import KeyMetric from '@components/KeyMetric';
import { Row } from '@simplywallst/ui-core';
import { KeyMetricWrapper } from './styled';

export interface TeamTenureProps {
  dataCyId?: string;
  tenure: string | null;
  averageAge?: number;
}

const TeamTenure = ({
  dataCyId,
  tenure = null,
  averageAge,
}: TeamTenureProps) => {
  return (
    <Row data-cy-id={`team-tenure-${dataCyId}`}>
      <KeyMetricWrapper col={12} colSm={4}>
        <KeyMetric
          title="Average Tenure"
          size="large"
          metric={`${tenure}yrs`}
        />
      </KeyMetricWrapper>
      {averageAge && averageAge > 0 ? (
        <KeyMetricWrapper col={12} colSm={4}>
          <KeyMetric
            title="Average Age"
            size="large"
            metric={`${averageAge}yo`}
          />
        </KeyMetricWrapper>
      ) : null}
    </Row>
  );
};

export default TeamTenure;
